import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BookingCard from "examples/Cards/BookingCard";
// import Modal from 'react-modal';

// Images
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { useState, useEffect, useMemo, useRef } from "react";
import MDButton from "../../../../components/MDButton";
import { saveAs } from 'file-saver';
import Modal from "@mui/material/Modal";
import { modalStyleUser } from "../../../../components/Utils/ModalStyle";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../../components/MDInput";
import { TextField } from "@mui/material";
import Switch from "@mui/material/Switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import AuthService from "../../../../services/auth.service";
import InstancesService from "../../../../services/instances.service";
import ClientsService from "../../../../services/clients.service";
import userService from "../../../../services/user.service";
import { SnackShower } from "../../../../components/Utils/Tools";
import UnitCreateModal from "../../../../components/UnitCreateModal";

const filterUnitOptions = (options, { inputValue }) => {
    const search = inputValue.trim().toLowerCase();
    const matches = options.filter((option) => unitLabel(option).toLowerCase().includes(search));
    if (/^\d+$/.test(search)) {
        const exists = options.some((option) => String(option.unit || "").trim() === search);
        matches.push({ id: "add-unit", unit: exists ? `Add unit "${search}" on another floor` : `Add unit "${search}"`, newUnitNumber: search });
    }
    return matches;
};
const unitLabel = (option) => option?.newUnitNumber
    ? option.unit
    : option?.unit ? `${option.unit} — Floor ${option.floor || "?"}, Section ${option.section || "?"}` : "";

function InsertUserComponent({ settings, setSettings, snackBarSetting, setSnackBarSetting, ...ref }) {
    const defaultInputValues = { email: '', phone: '', firstName: '', lastName: '', mainPerson: false, for_other_daily_amenity_limit: 0 }
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [buttonIcon, setButtonIcon] = useState("");
    const [currentFile, setCurrentFile] = useState(null);
    // const [isValid, setIsValid] = useState(null);
    const [values, setValues] = useState(defaultInputValues);

    let userRole = AuthService.getUserRole();

    const [instanceList, setInstanceList] = useState([]);
    const [selectedInstance, setSelectedInstance] = useState({});
    const [clientList, setClientList] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [buildingList, setBuildingList] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState({});
    const [unitList, setUnitList] = useState([]);
    const unitRequestRef = useRef(0);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [unitSearch, setUnitSearch] = useState("");
    const [showAddUnit, setShowAddUnit] = useState(false);
    const [newUnitNumber, setNewUnitNumber] = useState("");

    const isStaffPage = settings.type === "staff";
    const isUserPage = settings.type === "user";

    const roleOptions = (() => {
        let all = [
            { id: 2, label: "Admin" },
            { id: 4, label: "Staff" },
            { id: 3, label: "Member" },
        ];

        if (isStaffPage) {
            return all.filter(r => r.id === 2 || r.id === 4);
        }

        if (isUserPage) {
            return all.filter(r => r.id === 3);
        }

        if (userRole === "super_admin") return all;
        if (userRole === "admin") return all.filter(r => r.id === 4 || r.id === 3);
        if (userRole === "staff") return all.filter(r => r.id === 3);

        return [];
    })();

    useEffect(() => {
        if (settings.type === "user") {
            setSelectedRole({ id: 3, label: "Member" });
        }

        if (settings.type === "staff") {
            setSelectedRole({ id: 2, label: "Admin" }); 
        }
    }, [settings.type]);

    //const [selectedRole, setSelectedRole] = useState(roleOptions.length > 0 ? roleOptions[roleOptions.length - 1] : { id: 3, label: "Member" });
    const [selectedRole, setSelectedRole] = useState(
        roleOptions.length > 0 ? roleOptions[0] : null
    );
    const loadInstance = () => {
        InstancesService.getInstances()
            .then((val) => {
                setInstanceList(val.data);
                if (val.data.length > 0) {
                    handleChange({ ...values, instance: val.data[0] });
                    setSelectedInstance(val.data[0]);
                    loadClient(val.data[0].id)
                }
            }).catch((e) => { console.log() })
    }
    const loadClient = (instance_id) => {
        ClientsService.getClients(instance_id)
            .then((val) => {
                setClientList(val.data);
                if (val.data.length > 0) {
                    handleChange({ ...values, client: val.data[0] });
                    setSelectedClient(val.data[0]);
                    loadBuilding(val.data[0].id);
                }
            }).catch((e) => { console.log() });
    }
    const loadBuilding = (client_id) => {
        ClientsService.getClientsBuilding(client_id)
            .then((val) => {
                setBuildingList(val.data);
                if (val.data.length > 0) {
                    handleChange({ ...values, building: val.data[0] });
                    setSelectedBuilding(val.data[0]);
                    loadUnits(val.data[0].id);
                }
            }).catch((e) => { console.log() });
    }
    const loadUnits = (building_id) => {
        const requestId = ++unitRequestRef.current;
        setUnitList([]);
        setSelectedUnit(null);
        setUnitSearch("");
        ClientsService.getBuildingUnits(building_id)
            .then((val) => {
                if (requestId === unitRequestRef.current)
                    setUnitList(Array.isArray(val.data) ? val.data : []);

            }).catch((e) => { console.log() });
    }
    useEffect(() => {
        // console.log("Hello");

        if (userRole === "super_admin") {
            if (instanceList.length === 0) {
                loadInstance();
            }
        } else if (userRole === "admin") {
            if (clientList.length === 0) {
                loadClient();
            }
        } else if (userRole === "staff") {
            if (clientList.length === 0) {
                loadClient();
            }
        }
    }, []);


    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    const validationSchema = Yup.object().shape({
        email: Yup.string().email("Email is not valid").required('Email is required'),
        phone: isUserPage ? Yup.string().required('Phone is required') : Yup.string(),
        firstName: Yup.string().required('First Name is required'),
        lastName: isUserPage ? Yup.string().required('Last Name is required') : Yup.string(),
        unit: Yup.mixed(),
        client: Yup.mixed(),
        instance: Yup.mixed(),
        building: Yup.mixed(),
    });

    const { register, handleSubmit, formState: { errors, isValid } } =
        useForm({ mode: "all", resolver: yupResolver(validationSchema) });

    const [fieldErrors, setFieldErrors] = useState({});
    const handleChange = (value) => setValues(value)
    const handleChange2 = (key, value) => {
        console.log(key, value);
        if (key === 'instance') {
            setSelectedInstance(value);
        }
        if (key === 'client') {
            setSelectedClient(value);
        }
        if (key === 'building') {
            setSelectedBuilding(value);
        }
        if (key === 'unit') {
            // setUnitList({...unitList, {id:0, "unit":value}})
            setSelectedUnit(value);
        }
    }

    // setInterval(()=>{setIsValid(validationSchema.isValidSync(values))}, 1000);

    const onFileChange = event => { setCurrentFile(event.target.files[0]); };

    const onFileUpload = () => {
        setUploadInProgress(true);
        setButtonIcon("sync");
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append("myFile", currentFile, currentFile.name);
        formData.append("client", selectedClient.id);

        // Details of the uploaded file
        console.log(formData);
        // setInterval(1000, function finish() { })

        userService.createBulk(formData)
            .then((val) => {
                console.log(val);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                window.location.reload(true);
            }).catch((e) => {
                console.log(e);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: e.toString() })
            })
        // Request made to the backend api
        // Send formData object
        // post("api/uploadfile", formData);
    };

    const handleDownloadCsv = (e) => { saveAs(process.env.PUBLIC_URL + "/resource/template.csv", "template.csv"); };

    const myRef = useRef(null);

    const clickElement = (ref) => {
        ref.current.dispatchEvent(
            new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true,
                buttons: 1,
            }),
        );
    };

    const onClickSaveData = (e) => {
        e.preventDefault();
        if (isUserPage && !validateUserForm()) {
            setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: "Please fill all required fields" });
            return;
        }
        // alert("clicked, " + isValid);
        if (isValid || isUserPage) {
            const payload = { ...values };
            payload["mainPerson"] = values["mainPerson"].toString();
            payload["client"] = selectedClient.id?.toString();
            // values["instance"] = selectedInstance.id.toString();
            payload["building"] = selectedBuilding.id?.toString();
            payload["unit_id"] = selectedUnit?.id?.toString();
            payload["role"] = selectedRole.id.toString()
            if (isStaffPage) {
                payload["for_other_daily_amenity_limit"] =
                    values.for_other_daily_amenity_limit === null
                        ? null
                        : String(values.for_other_daily_amenity_limit || 0);
            }
            // console.log(values);
            userService.createSingle(payload)
                .then((val) => {
                    console.log(val);
                    //
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                    window.location.reload(true);
                }).catch((reason) => {
                    console.log(reason.response.data.status);
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: reason.response.data.status })
                })
        }

        // console.log(values);
    }

    const isEmptyObject = (value) => !value || (typeof value === "object" && Object.keys(value).length === 0);

    const validateUserForm = () => {
        const nextErrors = {};

        if (userRole === "super_admin" && isEmptyObject(selectedInstance)) {
            nextErrors.instance = "Instance is required";
        }
        if (isEmptyObject(selectedClient)) {
            nextErrors.client = "Client is required";
        }
        if (isEmptyObject(selectedBuilding)) {
            nextErrors.building = "Building is required";
        }
        if (!selectedUnit?.id) {
            nextErrors.unit = "Unit is required";
        }
        if (!values.email || !values.email.trim()) {
            nextErrors.email = "Email is required";
        }
        if (!values.phone || !values.phone.trim()) {
            nextErrors.phone = "Phone is required";
        }
        if (!values.firstName || !values.firstName.trim()) {
            nextErrors.firstName = "First Name is required";
        }
        if (!values.lastName || !values.lastName.trim()) {
            nextErrors.lastName = "Last Name is required";
        }
        if (!selectedRole) {
            nextErrors.role = "Role is required";
        }

        setFieldErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    return (
        <Modal open={settings.show} color={"warning"} onClose={(e) => { setSettings({ ...settings, show: false }) }}>
            <MDBox sx={modalStyleUser}>
                <Card id="basic-info" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h5">Insert {settings.showBulk ? "User" : "Staff"} </MDTypography> {/*In {settings.title}*/}
                    </MDBox>
                    <MDBox component="form" pb={3} >
                        <Grid container textAlign={"center"} >
                            <Grid container spacing={2} pt={2} px={2} xs={12} md={12}  >
                                {!isStaffPage && userRole === "super_admin" && (userRole === "super_admin") ? <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        disableClearable
                                        options={!instanceList ? [] : instanceList}
                                        value={selectedInstance}
                                        getOptionLabel={(option) => option.name || "None"}
                                        onChange={(e, v) => {
                                            handleChange2('instance', v);
                                            loadClient(v.id)
                                        }}
                                        renderInput={(params) =>
                                            <MDInput {...params} label={"Select Instance"}
                                                required={isUserPage}
                                                error={!!fieldErrors.instance || !!errors.instance}
                                                helperText={fieldErrors.instance || errors.instance?.message} />}
                                    />
                                </Grid> : ""}
                                {!isStaffPage && (userRole === "staff" || userRole === "admin" || userRole === "super_admin") ? <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        disableClearable
                                        options={!clientList ? [] : clientList}
                                        value={selectedClient}
                                        getOptionLabel={(option) => option.client_name || "None"}
                                        onChange={(e, v) => {
                                            handleChange2('client', v);
                                            loadBuilding(v.id)
                                        }}
                                        renderInput={(params) =>
                                            <MDInput {...params} label={"Select Client"}
                                                required={isUserPage}
                                                error={!!fieldErrors.client || !!errors.client}
                                                helperText={fieldErrors.client || errors.client?.message} />}
                                    />
                                </Grid> : ""}
                                {!isStaffPage && (userRole === "staff" || userRole === "admin" || userRole === "super_admin") ? <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        disableClearable
                                        options={!buildingList ? [] : buildingList}
                                        value={selectedBuilding}
                                        getOptionLabel={(option) => option.name || "None"}
                                        onChange={(e, v) => {
                                            handleChange2('building', v);
                                            loadUnits(v.id);
                                        }}
                                        renderInput={(params) =>
                                            <MDInput {...params} label={"Select Building"}
                                                required={isUserPage}
                                                error={!!fieldErrors.building || !!errors.building}
                                                helperText={fieldErrors.building || errors.building?.message} />}
                                    />
                                </Grid> : ""}
                                {!isStaffPage && (userRole === "staff" || userRole === "admin" || userRole === "super_admin") ? <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        options={!unitList ? [] : unitList}
                                        value={selectedUnit || null}
                                        inputValue={unitSearch}
                                        filterOptions={filterUnitOptions}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionLabel={unitLabel}
                                        onChange={(e, v) => {
                                            if (v?.newUnitNumber) {
                                                setNewUnitNumber(v.newUnitNumber);
                                                setShowAddUnit(true);
                                            } else {
                                                setSelectedUnit(v);
                                                setUnitSearch(unitLabel(v));
                                            }
                                        }}
                                        onInputChange={(e, input, reason) => {
                                            if (reason === "input") {
                                                setUnitSearch(input);
                                                setSelectedUnit(null);
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <MDInput {...params} label={"Select Unit"}
                                                required={isUserPage}
                                                error={!!fieldErrors.unit || !!errors.unit}
                                                helperText={fieldErrors.unit || errors.unit?.message} />}
                                    />
                                </Grid> : ""}
                            </Grid>
                            <Grid container spacing={3} pt={4} px={2} xs={12} md={settings.showBulk ? 6 : 12} >
                                <Grid item xs={12} md={12}>
                                    <MDBox pl={3}>
                                        <MDTypography variant="h6">Create  {settings.showBulk ? "Single User" : "Staff"}</MDTypography>
                                    </MDBox>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required fullWidth type="email" label="Email" name="email"
                                        error={!!fieldErrors.email || !!errors.email}
                                        helperText={fieldErrors.email || errors.email?.message}
                                        value={values.email}
                                        autoComplete="new-password"
                                        {...register("email")}
                                        onChange={(event) =>
                                            handleChange({ ...values, email: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required={isUserPage} fullWidth type="text" label="Phone" name="phone"
                                        error={!!fieldErrors.phone || !!errors.phone}
                                        helperText={fieldErrors.phone || errors.phone?.message}
                                        value={values.phone}
                                        autoComplete="new-password"
                                        {...register("phone")}
                                        onChange={(event) =>
                                            handleChange({ ...values, phone: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required fullWidth type="text" label="First Name" name="firstName"
                                        error={!!fieldErrors.firstName || !!errors.firstName}
                                        helperText={fieldErrors.firstName || errors.firstName?.message}
                                        value={values.firstName}
                                        {...register("firstName")}
                                        onChange={(event) =>
                                            handleChange({ ...values, firstName: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required={isUserPage} fullWidth type="text" label="Last Name" name="lastName"
                                        error={!!fieldErrors.lastName || !!errors.lastName}
                                        helperText={fieldErrors.lastName || errors.lastName?.message}
                                        value={values.lastName}
                                        {...register("lastName")}
                                        onChange={(event) =>
                                            handleChange({ ...values, lastName: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Autocomplete
                                        disableClearable
                                        options={roleOptions}
                                        value={selectedRole}
                                        getOptionLabel={(option) => option.label || ""}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={(e, v) => { if (v) setSelectedRole(v); }}
                                        renderInput={(params) =>
                                            <MDInput {...params} label={"Role"}
                                                required={isUserPage}
                                                error={!!fieldErrors.role}
                                                helperText={fieldErrors.role} />}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDBox display={settings.showBulk ? "flex" : "none"} alignItems="center" mb={0.5} ml={-1.5}>

                                        <MDBox width="80%" ml={0.5}  >
                                            <MDTypography variant="button" fontWeight="regular" color="text">
                                                Is Main Person ?
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox mt={0.5} >
                                            <Switch checked={values.mainPerson} onChange={(event, checked) => {
                                                setValues({ ...values, mainPerson: checked })
                                            }} />
                                        </MDBox>
                                    </MDBox>
                                </Grid>
                                {isStaffPage && (
                                    <Grid item xs={12}>
                                        <MDBox display="flex" alignItems="center" mb={1}>
                                            <Switch
                                                checked={values.for_other_daily_amenity_limit === null}
                                                onChange={(event, checked) =>
                                                    handleChange({ ...values, for_other_daily_amenity_limit: checked ? null : 0 })}
                                            />
                                            <MDTypography variant="button" fontWeight="regular" color="text">
                                                Unlimited
                                            </MDTypography>
                                        </MDBox>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Daily booking limit per amenity"
                                            value={values.for_other_daily_amenity_limit === null ? 0 : values.for_other_daily_amenity_limit}
                                            disabled={values.for_other_daily_amenity_limit === null}
                                            inputProps={{ min: 0 }}
                                            helperText="How many bookings this staff/admin can make for others per amenity per day. Select Unlimited for no limit."
                                            onChange={(event) =>
                                                handleChange({ ...values, for_other_daily_amenity_limit: event.target.value })}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                            <Grid container spacing={3} pt={4} px={2} xs={12} md={6}
                                sx={settings.showBulk ? { "display": "flex" } : { "display": "none" }} >
                                <Grid item xs={12} md={12}>
                                    <MDBox pl={3}>
                                        <MDTypography variant="h6">Create Bulks User</MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <input type={"file"} accept={".csv"} style={{ "display": "none" }} onChange={onFileChange} ref={myRef} />
                                    <MDButton size={"large"} fullWidth color={"primary"} variant={"gradient"}
                                        style={{ display: currentFile === null ? 'block' : 'none' }} disabled={uploadInProgress}
                                        onClick={() => clickElement(myRef)}>
                                        Select Csv of Users
                                    </MDButton>
                                    <MDButton size={"large"} color={"success"}
                                        disabled={currentFile === null || uploadInProgress} fullWidth style={{ display: currentFile === null ? 'none' : 'block' }} variant={"gradient"} onClick={onFileUpload}>
                                        Start creating users
                                    </MDButton>
                                    <Icon style={{ display: buttonIcon === "" ? "none" : "inline" }} fontSize={"small"}>{buttonIcon}</Icon>
                                    <br />

                                    <MDButton fullWidth onClick={handleDownloadCsv}>
                                        <MDTypography variant="h6" fontWeight={"light"} opacity={0.6}
                                            color={"secondary"}>Click here for download template csv</MDTypography>
                                    </MDButton>
                                    <MDTypography variant="caption" color="text">
                                        Units in the CSV must already exist. A unit number used on multiple floors must be assigned manually.
                                    </MDTypography>
                                </Grid>
                            </Grid>
                            <Grid spacing={2} pt={4} item xs={12} md={12} textAlign={"center"} >
                                <MDButton color={"info"} size={"large"} sx={{ width: '50%' }} disabled={!isValid && !isUserPage}
                                    onClick={onClickSaveData} >Save Data</MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            <UnitCreateModal open={showAddUnit}
                building={{ id: selectedBuilding?.id, building_name: selectedBuilding?.name }}
                initialNumber={newUnitNumber}
                onClose={() => setShowAddUnit(false)}
                onCreated={(unit) => {
                    const option = { id: unit.id, unit: unit.unit, floor: unit.floor, section: unit.section };
                    setUnitList((current) => [...current, option]);
                    setSelectedUnit(option);
                    setUnitSearch(unitLabel(option));
                    setShowAddUnit(false);
                    setFieldErrors((current) => ({ ...current, unit: undefined }));
                }} />
            </MDBox>
        </Modal>)

}

export default InsertUserComponent;
